import http from "./http_common";

class RPMService {
  queryString(payload) {
    const QueryString = Object.keys(payload)
      .map((key) => key && payload[key] && key + "=" + payload[key])
      .join("&");
    return QueryString;
  }
  rpmCalenderActivity(payload) {
    const queryString = this.queryString(payload);
    return http.get(`/patient/getCalenderDetail?${queryString}`);
  }
}

export default new RPMService();
